"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMessageDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class AppMessageDto {
    constructor(params) {
        this.messageType = "";
        this.subject = "";
        this.body = "";
        this.label = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.messageType = params.messageType;
        this.subject = params.subject;
        this.body = params.body;
        this.label = params.label;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
    }
}
exports.AppMessageDto = AppMessageDto;
//# sourceMappingURL=AppMessageDto.js.map